import React from "react";
import { lePetitPrinceImages } from "../../../../Assets/images/le-petit-prince";
import StyledDiv from "../../../StyledDiv/StyledDiv";
import { IStyledDivStyles } from "../../../StyledDiv/StyledDiv";
import {
  AnimatedCloudTopLeft,
  AnimatedCloudTopRight,
} from "../../LandingHeaderHighlightProduct/Decorations/GlobeGreen/CloudAnimation";
import AnimatedStarWrapper from "../../../Decorations/PetitPrince/Star/Variants/AnimatedStarWrapper";

interface IOrangeMoonProps {
  styles?: IStyledDivStyles;
}

const OrangeMoon = ({ styles }: IOrangeMoonProps) => {
  return (
    <StyledDiv
      styles={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        ...styles,
      }}
    >
      <StyledDiv
        styles={{
          position: "relative",
          display: "inline-block",
        }}
      >
        {/* Base element - Orange Moon */}
        <svg
          width="123"
          height="124"
          viewBox="0 0 123 124"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            display: "block",
            position: "relative",
            zIndex: 1,
          }}
        >
          <ellipse
            cx="61.5"
            cy="62"
            rx="61.5"
            ry="62"
            fill="url(#paint0_radial_2870_6215)"
          />
          <defs>
            <radialGradient
              id="paint0_radial_2870_6215"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(75.5263 63.0877 -62.5789 76.1404 47.4737 39.9737)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF9D6B" />
              <stop offset="1" stop-color="#FC561C" />
            </radialGradient>
          </defs>
        </svg>

        {/* Large Yellow Star - centrally placed, in front of orangeMoon, slightly offset towards bottom-left */}
        <img
          src={lePetitPrinceImages.yellowBigStar}
          alt="Yellow big star"
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            transform: "translate(21%, 23%)",
            width: "172px",
            height: "172px",
            zIndex: 2,
          }}
        />

        {/* Small Cloud (51px) - bottom-right quadrant */}
        <AnimatedCloudTopLeft
          as="img"
          src={lePetitPrinceImages.cloud}
          alt="Small cloud"
          style={{
            position: "absolute",
            bottom: "0%",
            right: "0%",
            transform: "translate(47%, -75%)",
            width: "51px",
            height: "auto",
            zIndex: 3,
          }}
        />

        {/* Large Cloud (65px) -  upper-left quadrant */}
        <AnimatedCloudTopRight
          as="img"
          src={lePetitPrinceImages.cloud}
          alt="Large cloud"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            transform: "translate(-46%, 28%)",
            width: "65px",
            height: "auto",
            zIndex: 3,
          }}
        />

        {/* Star Yellow A (21px) - far bottom-left corner */}
        <AnimatedStarWrapper
          as="img"
          src={lePetitPrinceImages.starYellowA}
          alt="Star yellow A"
          style={{
            position: "absolute",
            bottom: "0%",
            left: "0%",
            transform: "translate(-170%, -93%)",
            width: "21px",
            height: "auto",
            zIndex: 3,
          }}
          $animationDuration={3}
          $animationDelay={0}
        />

        {/* Star Yellow X (25px) - far top-right corner */}
        <AnimatedStarWrapper
          as="img"
          src={lePetitPrinceImages.starYellowX}
          alt="Star yellow X"
          style={{
            position: "absolute",
            top: "0",
            right: "0%",
            transform: "translate(140%, 12%)",
            width: "25px",
            height: "auto",
            zIndex: 3,
          }}
          $animationDuration={2}
          $animationDelay={0.2}
        />
      </StyledDiv>
    </StyledDiv>
  );
};

export default OrangeMoon;
